import type {AdminUser, AuthSession} from "@/types/auth.types";

export interface LoginTokens {
  accessToken: string;
  refreshToken: string;
  expires_in: number;
  token_type: string;
}

interface TokenPayload {
  sub: string;
  email?: string;
  preferred_username?: string;
  given_name?: string;
  family_name?: string;
  name?: string;
  realm_access?: {roles: string[]};
}

const decodeTokenPayload = (token: string): TokenPayload | null => {
  try {
    const base64 = token.split(".")[1];
    if (!base64) return null;
    const json = atob(base64.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json) as TokenPayload;
  } catch {
    return null;
  }
};

export const toAuthSession = (tokens: LoginTokens): AuthSession => {
  const {accessToken, refreshToken, expires_in} = tokens;
  const payload = decodeTokenPayload(accessToken);

  const user: AdminUser = {
    id: payload?.sub ?? "",
    email: payload?.email ?? payload?.preferred_username ?? "",
    fullName: payload?.name ?? (`${payload?.given_name ?? ""} ${payload?.family_name ?? ""}`.trim() || "Admin"),
    role: "admin",
  };

  return {
    user,
    accessToken: accessToken,
    refreshToken: refreshToken,
    expiresAt: Date.now() + expires_in * 1000,
  };
};
